import React from 'react';

const fixedFrame = () => {
  return (
    <>
      <svg viewBox="0 0 384 254" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ width: 'auto', height: 580 }}>
        <rect width={870} height={580} fill="none" />
      </svg>
    </>
  );
};

export default fixedFrame;
